// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"RentalPrice_infoButton__Srj6z","price":"RentalPrice_price__d8V4c"};